import React, { useState, useEffect } from "react";
import { ToastMessage, showToast } from "../../Shared/ToastMessage"
import axios from "axios"
import { localserver } from "../../../api/common"
import { FaArrowLeft, FaCheckCircle, FaTicketAlt, FaCalendarAlt, FaClock, FaUsers, FaArrowRight } from "react-icons/fa"
import CheckInChooseModal from "./CheckInChooseModal";

const PreviewCheckinModal = ({ show, onHide, checkinId }) => {
  const [getEventStatus, setGetEventStatus] = useState(false)
  const [checkinDetails, setCheckinDetails] = useState(null)
  const [showCheckinChooseModal, setShowCheckinChooseModal] = useState(false);
  const getCheckinDetailsByEvent = async () => {
    try {
      setGetEventStatus(true)
      const response = await axios.post(
        `${localserver}/checkin_master_details`,
        {
          id: checkinId,
          event_id: localStorage.getItem("eventId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      console.log("getEventDetailsByUser Response:", response.data)
      if (response.data.success) {
        setCheckinDetails(response.data.data)
      } else {
        console.error("Error: Failed to fetch user data")
        showToast("Failed to fetch events", "error")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
      showToast("An error occurred while fetching events", "error")
    } finally {
      setGetEventStatus(false)
    }
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A"
    return new Date(dateString).toLocaleString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  // Construct ticket data from API response
  const parseTicketData = () => {
    if (!checkinDetails) return [];
    const names = (checkinDetails.ticket_names || '').split(',').map(n => n.trim()).filter(Boolean);
    const attendees = checkinDetails.attendees || [];
    return attendees.map((att, index) => ({
      ticketName: names[index] || `Ticket ${index + 1}`,
      checkedIn: parseInt(att.checked_in_count || 0),
      total: parseInt(att.total_attendees || 0),
      checkInsCount: parseInt(att.checked_in_count || 0),
    }));
  };

  const ticketsCheckInData = parseTicketData();

  const totalCheckedIn = ticketsCheckInData.reduce((sum, t) => sum + t.checkedIn, 0);
  const totalAttendees = ticketsCheckInData.reduce((sum, t) => sum + t.total, 0);

  useEffect(() => {
    if (show) {
      getCheckinDetailsByEvent()
    }
  }, [show, checkinId])

  const calculatePercentage = (checkedIn, total) => {
    if (total === 0) return 0
    return Math.round((checkedIn / total) * 100)
  }

  return (
    <>
      <ToastMessage />
      {show && (
        <div
          className={`add_attendites_model member_master_sidebar_scrool search_div open`}
          style={{
            position: "fixed",
            right: 0,
            top: 0,
            width: "600px",
            height: "100vh",
            backgroundColor: "#f8f9fa",
            boxShadow: "-4px 0 24px rgba(0, 0, 0, 0.15)",
            // zIndex: 1050,
            overflowY: "auto",
            transition: "transform 0.3s ease-in-out",
          }}
        >
          {/* Header */}
          <div
            style={{
              position: "sticky",
              top: 0,
              backgroundColor: "#ffffff",
              padding: "24px",
              borderBottom: "1px solid #e5e7eb",
              zIndex: 10,
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#1a1a1a",
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <FaCheckCircle style={{ color: "#184778" }} />
                {checkinDetails && checkinDetails.checkin_name}
              </h3>
              <button
                onClick={() => onHide()}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 20px",
                  backgroundColor: "#184778",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#0f3554";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#184778";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <FaArrowLeft /> Back
              </button>
            </div>
          </div>

          {/* Content */}
          <div style={{ padding: "24px" }}>
            {getEventStatus ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "80px 20px",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{ width: "50px", height: "50px", color: "#184778" }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <p
                  style={{
                    marginTop: "20px",
                    color: "#6b7280",
                    fontSize: "16px",
                  }}
                >
                  Loading check-in details...
                </p>
              </div>
            ) : checkinDetails ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {/* Check-in Summary Card */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#184778",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      <FaUsers size={20} />
                    </div>
                    <h4
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#1a1a1a",
                        margin: 0,
                      }}
                    >
                      Check-in Summary
                    </h4>
                    <button
                    onClick={() => setShowCheckinChooseModal(true)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "10px 20px",
                      backgroundColor: "#184778",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#0f3554";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#184778";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    Check-in apps <FaArrowRight />
                  </button>
                  </div>

                  <div
                    style={{
                      backgroundColor: "#f9fafb",
                      borderRadius: "8px",
                      padding: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#6b7280",
                          fontWeight: "500",
                        }}
                      >
                        Total Check-ins
                      </span>
                      <span
                        style={{
                          fontSize: "24px",
                          fontWeight: "700",
                          color: "#184778",
                        }}
                      >
                        {totalCheckedIn}/{totalAttendees}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "12px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "6px",
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: `${calculatePercentage(
                            totalCheckedIn,
                            totalAttendees
                          )}%`,
                          height: "100%",
                          backgroundColor: "#10b981",
                          borderRadius: "6px",
                          transition: "width 0.3s ease",
                        }}
                      />
                    </div>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#6b7280",
                        marginTop: "8px",
                        marginBottom: 0,
                      }}
                    >
                      {calculatePercentage(
                        totalCheckedIn,
                        totalAttendees
                      )}
                      % attendees checked in
                    </p>
                  </div>
                </div>

                {/* Check-in Progress by Ticket */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#8b5cf6",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      <FaTicketAlt size={20} />
                    </div>
                    <h4
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#1a1a1a",
                        margin: 0,
                      }}
                    >
                      Check-in Progress by Ticket
                    </h4>
                  </div>

                  {ticketsCheckInData.map((ticket, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "#f9fafb",
                        borderRadius: "8px",
                        padding: "20px",
                        marginBottom:
                          index < ticketsCheckInData.length - 1 ? "16px" : "0",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "12px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#1a1a1a",
                          }}
                        >
                          {ticket.ticketName}
                        </span>
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#8b5cf6",
                          }}
                        >
                          {ticket.checkedIn}/{ticket.total}
                        </span>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          height: "10px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "5px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            width: `${calculatePercentage(
                              ticket.checkedIn,
                              ticket.total
                            )}%`,
                            height: "100%",
                            backgroundColor: "#8b5cf6",
                            borderRadius: "5px",
                            transition: "width 0.3s ease",
                          }}
                        />
                      </div>
                      <p
                        style={{
                          fontSize: "13px",
                          color: "#6b7280",
                          marginTop: "8px",
                          marginBottom: 0,
                        }}
                      >
                        {ticket.checkInsCount} check-ins (
                        {calculatePercentage(ticket.checkedIn, ticket.total)}%)
                      </p>
                    </div>
                  ))}
                </div>

                {/* Event Details Card */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#f59e0b",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      <FaCalendarAlt size={20} />
                    </div>
                    <h4
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#1a1a1a",
                        margin: 0,
                      }}
                    >
                      Check-in Details
                    </h4>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        paddingBottom: "16px",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#6b7280",
                          fontWeight: "500",
                        }}
                      >
                        Event Name
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#1a1a1a",
                          fontWeight: "600",
                          textAlign: "right",
                          maxWidth: "60%",
                        }}
                      >
                        {checkinDetails.event_name}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        paddingBottom: "16px",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#6b7280",
                          fontWeight: "500",
                        }}
                      >
                        Check-in Name
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#1a1a1a",
                          fontWeight: "600",
                          textAlign: "right",
                          maxWidth: "60%",
                        }}
                      >
                        {checkinDetails.checkin_name}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        paddingBottom: "16px",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#6b7280",
                          fontWeight: "500",
                        }}
                      >
                        Entry Type
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#1a1a1a",
                          fontWeight: "600",
                          textAlign: "right",
                          maxWidth: "60%",
                        }}
                      >
                        {`${checkinDetails.entry_type.charAt(0).toUpperCase()}${checkinDetails.entry_type.slice(1)}`}
                      </span>
                      
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        paddingBottom: "16px",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#6b7280",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <FaClock size={14} /> Start Date
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#1a1a1a",
                          fontWeight: "600",
                          textAlign: "right",
                        }}
                      >
                        {formatDate(checkinDetails.start_date)}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#6b7280",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <FaClock size={14} /> End Date
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#1a1a1a",
                          fontWeight: "600",
                          textAlign: "right",
                        }}
                      >
                        {formatDate(checkinDetails.end_date)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "80px 20px",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <p style={{ color: "#6b7280", fontSize: "16px" }}>
                  No event details available.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      <CheckInChooseModal
        isOpen={showCheckinChooseModal}
        onClose={() => setShowCheckinChooseModal(false)}
        checkinId={checkinId}        
      />

    </>
  );
}

export default PreviewCheckinModal